<template>
  <div class="PersonMissionList">
    <div v-if="list.length > 0">
      <person-mission-list-web :list="list" class="hidden-sm-and-down" />
      <person-mission-list-mob :list="list" class="hidden-md-and-up" />
    </div>
    <div v-else>
      <EmptyList />
    </div>
  </div>
</template>

<script>
import PersonMissionListWeb from "./PersonMissionListWeb.vue";
import PersonMissionListMob from "./PersonMissionListMob.vue";
export default {
  components: {
    PersonMissionListWeb,
    PersonMissionListMob,
  },
  props: {
    args: Object,
  },
  mounted() {
    this.GetPeriodBeginAndEndDate();
  },
  data() {
    return {
      list: [],
    };
  },
  methods: {
    GetPeriodBeginAndEndDate() {
      const params = new URLSearchParams();
      params.append("periodNumber", this.args.period);
      params.append("year", this.args.year);
      if (this.args.perno) {
        params.append("employeeId", this.args.perno);
      }

      this.$store
        .dispatch("GetPeriodBeginAndEndDate", { params })
        .then((result) => {
          ////console.log(result);
          if (result.type === "success") {
            if (result.data.length > 0) {
              let data = result.data[0];

              //console.log(data);
              this.PersonMissionList(data.BeginDate, data.EndDate);
            }
          }
        });
    },
    PersonMissionList(BeginDate, EndDate) {
      const params = new URLSearchParams();
      params.append("beginDate", BeginDate);
      params.append("endDate", EndDate);
      params.append("searchKind", "status = 10");
      if (this.args.perno) {
        params.append("perno", this.args.perno);
      }

      this.$store.dispatch("PersonMissionList", { params }).then((result) => {
        //console.log(result);
        if (result.type === "success") {
          this.list = result.data;
        }
      });
    },
  },
};
</script>

<style>
</style>